// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"176c500c1a66e95576d9","655":"f4bf3a4de3c49e893178"}[chunkId] + ".js";
};